import { TrackChangesVisibilityState } from '../model';
import { CommonConstants } from '../shared';

export const createDefaultTrackChangesVisibilityState =
  (): TrackChangesVisibilityState => ({
    masterVisible: true,
    insertionsVisible: true,
    deletionsVisible: true,
    formattingVisible: true,
  });

export const getTrackChangesVisibilityClassMap = (
  state: TrackChangesVisibilityState
): Record<string, boolean> => {
  const classes = CommonConstants.trackChangesVisibility;
  const hideAll = !state.masterVisible;

  return {
    [classes.hideAll]: hideAll,
    [classes.hideInsertions]: !hideAll && !state.insertionsVisible,
    [classes.hideDeletions]: !hideAll && !state.deletionsVisible,
    [classes.hideFormatting]: !hideAll && !state.formattingVisible,
  };
};
